import {BodySite, BodySiteSelector, buildErrorMessageGetter} from '@legit.health/ui';
import {Box} from '@mui/material';
import {TFunction} from 'i18next';
import {UseFormReturn, useWatch} from 'react-hook-form';
import StepTitle from '@/components/StepTitle';
import FormValues from '../../interfaces/FormValues';

export default function BodySiteField({
  form,
  bodySites,
  t
}: {
  form: UseFormReturn<FormValues>;
  bodySites: BodySite[];
  t: TFunction;
}) {
  const getErrorMessage = buildErrorMessageGetter(form.formState.errors, t);

  const value = useWatch({
    control: form.control,
    name: 'bodySiteCode'
  });

  function onChange(bodySiteCode: string | null) {
    form.setValue('bodySiteCode', bodySiteCode ?? '', {
      shouldValidate: true
    });
  }

  return (
    <Box
      sx={{
        '.MuiAutocomplete-endAdornment .MuiSvgIcon-root': {
          color: 'primary.main'
        }
      }}
    >
      <StepTitle title={t('ui:bodySite')} subtitle={t('app:selectBodySite')} />
      <BodySiteSelector
        value={value}
        onChange={onChange}
        bodySites={bodySites}
        name="bodySiteCode"
        id="bodySiteCode"
        property="code"
        errorMessage={getErrorMessage('bodySiteCode')}
        label={t('ui:diagnosticReport.bodySiteFieldLabel')}
      />
    </Box>
  );
}
